import React, { useEffect, useState } from "react";
import { Button, Empty, Select, Pagination, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import useSearchJDStore from "../../store/searchjd.store";
import useSettingstore from "../../store/settings.store";
import Filter from "../filter";
import "./JDSearch.scss";
import TeamAssignmentCard from "../TeamAssignmentCard";
import JDSearchResults from "../JDSearchResults";

const { Search } = Input;

export default function JDSearch(props) {
  const { searchInput, searchedJDdata, getSearchedJds } = useSearchJDStore();
  const { getSettingByKey, addOrUpdateSetting } = useSettingstore();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchBarInput, setSearchBarInput] = useState("");
  const persistedSearchInput = useSettingstore(
    (state) => state.settings?.find((s) => s.key === "searchInput")?.value,
  );

  useEffect(() => {
    if (persistedSearchInput) {
      setSearchBarInput(persistedSearchInput);
      getSearchedJds({
        search: stringToArray(persistedSearchInput),
        page: 1,
        limit: 10,
      });
    }
  }, []);

  const handlePageChange = (page, pageSize) => {
    getSearchedJds({
      search: stringToArray(searchBarInput),
      page,
      limit: pageSize,
    });
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const stringToArray = (str) => {
    const regex = /[^\s"']+|"([^"]*)"|'([^']*)'/g;
    const result = [];
    let match;

    while ((match = regex.exec(str)) !== null) {
      result.push(match[1] || match[2] || match[0]);
    }
    return result;
  };

  const handleSearch = () => {
    getSearchedJds({
      search: stringToArray(searchBarInput),
      page: 1,
      limit: 10,
    });
    addOrUpdateSetting({ key: "searchInput", value: searchBarInput });
  };

  return (
    <div className="searchJD-wrapper">
      <div className="searchJD-input-wrapper">
        <Search
          placeholder="Search JDs by title or keywords"
          value={searchBarInput}
          onChange={(e) => setSearchBarInput(e.target.value)}
          onSearch={handleSearch}
          enterButton={
            <>
              <SearchOutlined />
              <span style={{ marginLeft: 6 }}>Search again</span>
            </>
          }
          style={{ width: 400 }}
        />
      </div>
      <div className="searchJD-header">
        Results for : "
        {stringToArray(persistedSearchInput)
          ?.map((word) => {
            return word.charAt(0).toUpperCase() + word.slice(1);
          })
          .join(", ")}
        "
      </div>
      <div className="searchJD-title">
        ({searchedJDdata?.jd_list?.length || 0}) Jobs Found
      </div>

      <div></div>
      {searchedJDdata?.jd_list?.length > 0 ? (
        <>
          {searchedJDdata?.jd_list?.map((jd, idx) => (
            <JDSearchResults data={jd} index={idx} />
          ))}
        </>
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}
      <Pagination
        style={{
          marginTop: "30px",
          marginBottom: "30px",
          float: "inline-end",
        }}
        current={currentPage}
        pageSize={pageSize}
        total={searchedJDdata?.total}
        onChange={(page, pageSize) => {
          handlePageChange(page, pageSize);
        }}
        showSizeChanger
        pageSizeOptions={[10, 20, 50, 100, 150]}
      />
    </div>
  );
}
